import HttpClient from "../../services/HttpClient";
import PreviewManager from "../preview/PreviewManager";
import lodash from "lodash";
import {setDefaultBackgroundColor, setEyesAndModules} from "../../utils/common";
import {scannabilityCheck, generateImageCheckscannability} from "../../utils/scannability";
import configs from "../../configs";
import QrConfiguration from "../../models/QrConfiguration";
import { buildMediaFileForImageConfig } from "../../utils/imageConfigHelper";
import { barcodeFormatConstants, PREVIEW_IMAGE_SIZE } from "src/utils/constants";

class ImageConfigManager {

  constructor(httpClient = null) {
    this.httpClient = httpClient || new HttpClient(configs.API_DOMAIN_NAME);
    console.log(this.httpClient)
    this.url = `/qr/image/configs`;
    this.designerHttpClient = this.httpClient; // Use the same authenticated httpClient
  }

  async create(instance) {
    const mediaFiles = buildMediaFileForImageConfig(instance.mediaFiles);
    try {
      const data = {
        "name": instance.name,
        "qrPreview": instance.qrPreview,
        "data": instance.qrImageFormData,
        "owner": {
          "groupUuid":instance.groupUuid,
          "dimensions": instance.dimensions
        },
        "isExclusivelyGroupOwned": instance.isExclusivelyGroupOwned,
        "tags": instance.tags,
        "mediaFiles": mediaFiles,
        "barcodeFormat": instance.barcodeFormat ? instance.barcodeFormat : barcodeFormatConstants.QR_CODE,
      }
      const res = await this.httpClient.post(this.url, data);
      console.log('ImageConfigManager', res)
      return res
    } catch (e) {
      console.error(e);
      return null;
    }
  }
async applyToCode(instance) {
    const mediaFiles = buildMediaFileForImageConfig(instance.mediaFiles);
    try {
      const data = {
        "level":"qr",
        "name": "Designer QR",
        "qrPreview": instance.qrPreview,
        "data": instance.qrImageFormData,
        "owner": { "dimensions": ""},
        "mediaFiles": mediaFiles,
        "barcodeFormat": instance.barcodeFormat ? instance.barcodeFormat : barcodeFormatConstants.QR_CODE,
      }
      const res = await this.httpClient.post(this.url, data);
      console.log(res)
      return res
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async delete(uuid) {

    try {
      const url = `${this.url}/${uuid}`;
      const res = await this.httpClient.destroy(url);
      console.log("delete response in the try block ", res)
      return res
    } catch (e) {
      console.error("Failed to delete design", e.message)
      return null;
    }
  }

  async fetchAll(queryParams) {
    try {
      //only if its not a group query add isExclusivelyGroupOwned
      queryParams = Object.assign({
        ...queryParams,
        level: 'global'
      },
        lodash.isEmpty(queryParams.groupUuid) && {isExclusivelyGroupOwned: false}
      )
      const res = await this.httpClient.get(this.url, queryParams);
      console.log("response in get request", res)
      if (res && res.results) {
        return res
      }
    } catch (e) {
      console.error("Failed to get designs", e);
    }

    return null;
  }

  async fetchFilters (queryParams) {
    const url = '/sites/filters/imageConfigs'
    try {
      //only if its not a group query add isExclusivelyGroupOwned
      queryParams = Object.assign({
          ...queryParams,
          level: 'global'
        },
        lodash.isEmpty(queryParams.groupUuid) && {isExclusivelyGroupOwned: false}
      )
      const res = await this.httpClient.get(url, queryParams);
      console.log("response in get request", res)
      if (res) {
        return res
      }
    } catch (e) {
      console.error("Failed to get designs", e);
    }
    return null;
  }

  async update(instance, colorStore, defaultImageConfig, v1ImageConfig) {
    let extendConfig = JSON.parse(instance.data)
    let isDefaultDesignerConfig = true
    // setDefaultBackgroundColor(extendConfig)
    // setEyesAndModules(extendConfig)
    const previewManager = new PreviewManager(this.httpClient, defaultImageConfig, v1ImageConfig)
    const scanabilityCheckConfig = {
      qrImageFormData: JSON.stringify({...extendConfig}),
      shortUrl: ""
    }
    
    setEyesAndModules(extendConfig)
    extendConfig.addThreeEyelidColors = colorStore.addThreeEyelidColors
    const scanabilityImage = await previewManager.create(scanabilityCheckConfig)
    if(scanabilityImage){  const scanabilityCheck = await scannabilityCheck(scanabilityImage.base64Image)}
  
    const formDataForIcon = JSON.stringify({...extendConfig ,size: PREVIEW_IMAGE_SIZE.size, resolution: PREVIEW_IMAGE_SIZE.resolution, unitsOfMeasure: PREVIEW_IMAGE_SIZE.unit, showImageSizeOrModuleWidth: true})
    const config = {
      qrImageFormData: formDataForIcon,
      shortUrl: ""
    }
    const isSavingConfig = true
    const resp = await previewManager.create(config, isSavingConfig)
    try {
      let qrPreview = resp.base64Image
      const mediaFiles = buildMediaFileForImageConfig(instance.mediaFiles);
      const data = {
        "name": instance.name ? instance.name : "You forgot to name me",
        "qrPreview": qrPreview,
        "data": JSON.stringify(extendConfig),
        "owner":{
          "groupUuid":instance.groupUuid,
          "dimensions": instance.dimensions
        },
        "isExclusivelyGroupOwned" : instance.isExclusivelyGroupOwned,
        "tags": instance.tags,
        "mediaFiles": mediaFiles,
        "barcodeFormat": instance.barcodeFormat ? instance.barcodeFormat : barcodeFormatConstants.QR_CODE,
      }
      const url = `${this.url}/${instance.uuid}`
      const res = await this.httpClient.put(url, data);
      if (res.data) {
        console.log("Successfully updated", res)
        return res
      }
    } catch (e) {
      // instance.handleHasErrors(true)
      // instance.handleErrorMessage(e.message)
      console.log("failed to update code: ", e.message);
    }
  }

  async updateApplyToCode(extendData, uuid, defaultImageConfig, v1ImageConfig, logoStore) {
    let extendConfig = JSON.parse(extendData)
    // setDefaultBackgroundColor(extendConfig)
    const previewManager = new PreviewManager(this.designerHttpClient, defaultImageConfig)
    const scanabilityCheck = await generateImageCheckscannability(extendConfig, defaultImageConfig, v1ImageConfig, this.designerHttpClient)
    const formDataForIcon = JSON.stringify({...extendConfig ,size: PREVIEW_IMAGE_SIZE.size, resolution: PREVIEW_IMAGE_SIZE.resolution, unitsOfMeasure: PREVIEW_IMAGE_SIZE.unit, showImageSizeOrModuleWidth: true})
    let isDefaultDesignerConfig = true
    if(extendConfig.isDefaultDesigner === false) {
      isDefaultDesignerConfig = extendConfig.isDefaultDesigner
    }
    const iconConfig = {
      qrImageFormData: formDataForIcon,
      shortUrl: ""
    }
    //const previewManager = new PreviewManager(this.designerHttpClient)
    const resp = await previewManager.create(iconConfig)
    try {
      const mediaFiles = buildMediaFileForImageConfig(logoStore);
      let data = {
        "level":"qr",
        "name": "Designer QR",
        "qrPreview": resp.base64Image,
        "data": JSON.stringify(extendConfig),
        "owner": {"dimensions": "" },
        "mediaFiles": mediaFiles,
        "barcodeFormat": extendConfig.barcodeFormat ? extendConfig.barcodeFormat : barcodeFormatConstants.QR_CODE,
      }

      const url = `${this.url}/${uuid}`
      const res = await this.httpClient.put(url, data);
      if (res.data) {
        console.log("Successfully updated", res)
        return res
      }
    } catch (e) {
      // instance.handleHasErrors(true)
      // instance.handleErrorMessage(e.message)
      console.log("failed to update code: ", e.message);
    }
  }


  async fetchWithId(uuid) {
    const payload = async () => {
      try {
        const res = await this.httpClient.get(this.url + "/" + uuid);
        if (res?.qrPreview) {
          const data = {
            image: res.qrPreview,
            label: res.name,
            isExclusivelyGroupOwned: res?.isExclusivelyGroupOwned,
            name: res.name,
            qrConfig: res.data,
            uuid: res.uuid,
            owner: res.owner,
            level: (res.level||""),
            tags: res.tags,
            mediaFiles: res?.mediaFiles,
            barcodeFormat: res?.barcodeFormat ? res.barcodeFormat : barcodeFormatConstants.QR_CODE,
          }
          return data
        }
      } catch (e) {
        console.error("Failed to get design", e);
      }

    }
    return await payload()
  }

  async addImageConfigForCode(instance, extendConfig) {
    // Ensure showImageSizeOrModuleWidth is persisted and conflicting key removed
    instance.designerViewStore.updateExtendConfig("showImageSizeOrModuleWidth", instance.designerViewStore.imageCharsStore.showImageSizeOrModuleWidth)
    instance.designerViewStore.cleanSizeAndModuleWidth()
    extendConfig = instance.designerViewStore.extendConfig

    const qrPreviewResp = await instance.createQrPreview(extendConfig)
    let isDefaultDesignerConfig = true
    if(JSON.parse(extendConfig).isDefaultDesigner === false) {
      isDefaultDesignerConfig = JSON.parse(extendConfig).isDefaultDesigner
    }
    let qrPreview;
    if (qrPreviewResp?.status >= 200 && qrPreviewResp?.status < 300) {
      if(!isDefaultDesignerConfig) {
        qrPreview = `data:image/png;base64,` + qrPreviewResp.base64Image
      } else {
        qrPreview = `data:image/${qrPreviewResp.imageFormat};base64,` + qrPreviewResp.base64Image
      }
    }
    const mediaFiles = buildMediaFileForImageConfig(instance.designerViewStore.logoStore);
    const configImagePayload = {
      qrImageFormData: extendConfig,
      "name": "",
      "qrPreview": qrPreview,
      "mediaFiles": mediaFiles,
      "barcodeFormat": extendConfig.barcodeFormat ? extendConfig.barcodeFormat : barcodeFormatConstants.QR_CODE,
    }
    const newImageConfig = await this.applyToCode(configImagePayload)
    const newConfig = QrConfiguration.create({
      level: newImageConfig.data.level,
      uuid: newImageConfig.data.uuid,
      label: newImageConfig.data.name,
      name: newImageConfig.data.name,
      qrConfig: newImageConfig.data.data,
      image: newImageConfig.data.qrPreview,
      mediaFiles: newImageConfig.data.mediaFiles,
    })
    instance.designerViewStore.qrConfigSelectStore.configStore.addImageToList(newConfig)
    return newImageConfig.data.uuid
  }
}

export default ImageConfigManager;
